import { Reducer } from "redux";
import { PushBreadcrumbProviderAction, PopBreadcrumbProviderAction, ResetBreadcrumbsProvidersAction, POP_BREADCRUMB_PROVIDER, PUSH_BREADCRUMB_PROVIDER, RESET_BREADCRUMBS_PROVIDERS } from "~/actions/breadcrumbProvider";
import { BreadcrumbItemProvider } from "~/types/resource";

type ActionTypes =
  | PushBreadcrumbProviderAction
  | PopBreadcrumbProviderAction
  | ResetBreadcrumbsProvidersAction
  ;


export const breadcrumbProviderReducer: Reducer<BreadcrumbItemProvider[], ActionTypes> = (
  previousState = [],
  action
) => {
  switch (action.type) {
    case PUSH_BREADCRUMB_PROVIDER: {
      const i = previousState.findIndex(p => p.pathname === action.payload.pathname)
      if (i > -1) {
        return [...previousState.slice(0, i), action.payload]
      } else {
        return [...previousState, action.payload]
      }
    }
    case POP_BREADCRUMB_PROVIDER: {
      if (previousState.length === 0) {
        return previousState
      }
      const tail = previousState[previousState.length - 1]
      return (tail.pathname === action.pathname
        ? previousState.slice(0, previousState.length - 2)
        : previousState)
    }
    case RESET_BREADCRUMBS_PROVIDERS: {
      return previousState.length === 0 ? previousState : []
    }
    default: return previousState
  }
}

export const getBreadcrumbProviders = (state:any): BreadcrumbItemProvider[]|undefined =>
  state.od.breadcrumbProvider ?? undefined;

